import { render } from "./help-center.vue?vue&type=template&id=4ade72f1"
const script = {}

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__